import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { CrmOrcamentosComponent } from './features/crm-orcamentos/crm-orcamentos.component';
import { WorkflowBoardComponent } from './features/workflow-board/workflow-board.component';
import { WorkflowDetailComponent } from './features/workflow-detail/workflow-detail.component';
import { DashboardsComponent } from './features/dashboards/dashboards.component';
import { RelatoriosGestaoFunilOrcamentosComponent } from './features/relatorios-gestao-funil-orcamentos/relatorios-gestao-funil-orcamentos.component';
import { RelatoriosGestaoSlaProducaoComponent } from './features/relatorios-gestao-sla-producao/relatorios-gestao-sla-producao.component';
import { RelatoriosGestaoWipCapacidadeComponent } from './features/relatorios-gestao-wip-capacidade/relatorios-gestao-wip-capacidade.component';
import { RelatoriosProcessoTempoEtapaComponent } from './features/relatorios-processo-tempo-etapa/relatorios-processo-tempo-etapa.component';
import { RelatoriosProcessoDiasParadoComponent } from './features/relatorios-processo-dias-parado/relatorios-processo-dias-parado.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'crm', component: CrmOrcamentosComponent },
  { path: 'workflow', component: WorkflowBoardComponent },
  { path: 'workflow/:id', component: WorkflowDetailComponent },
  { path: 'dashboards', component: DashboardsComponent },
  { path: 'relatorios/gestao/funil-orcamentos', component: RelatoriosGestaoFunilOrcamentosComponent },
  { path: 'relatorios/gestao/sla-producao', component: RelatoriosGestaoSlaProducaoComponent },
  { path: 'relatorios/gestao/wip-capacidade', component: RelatoriosGestaoWipCapacidadeComponent },
  { path: 'relatorios/processo/tempo-por-etapa', component: RelatoriosProcessoTempoEtapaComponent },
  { path: 'relatorios/processo/dias-parado', component: RelatoriosProcessoDiasParadoComponent },
  { path: '**', redirectTo: '' },
];
